import script from "./loaderGenerateTask.vue?vue&type=script&lang=ts&setup=true"
export * from "./loaderGenerateTask.vue?vue&type=script&lang=ts&setup=true"

import "./loaderGenerateTask.vue?vue&type=style&index=0&id=7d572a1f&lang=css"

const __exports__ = script;

export default __exports__